import React from 'react';
import classnames from 'classnames';
import SiteFooter from '@wix/da-shared-react/pkg/SiteFooter';
import { BiDataHook } from '@wix/da-shared-react/pkg/biLogger';
import Header from '../Header';
import s from './PageContainer.scss';

export interface Props {
  withTabHeader?: boolean;
  isSearchPage?: boolean;
  withFooter?: boolean;
  className?: string;

  // only supported by networkbar branch, here for compat
  withNetworkBar?: boolean;
  title?: React.ReactNode;
  tagLine?: React.ReactNode;
  headerNavigation?: React.ReactNode;
  headerRightSideContent?: React.ReactNode;
  children?: React.ReactNode;
}

export const PageContainer: React.FC<Props> = ({
  children,
  withTabHeader = true,
  isSearchPage,
  withFooter = false,
  className,
}) => {
  const pageClasses = classnames(
    s['page'],
    isSearchPage && s['search'],
    withTabHeader && s['with-header']
  );
  return (
    <>
      {withTabHeader && <Header />}
      <div className={pageClasses} data-hook={BiDataHook.BROWSE_ALL_CONTENT}>
        <div className={className}>{children}</div>
      </div>
      {withFooter && <SiteFooter />}
    </>
  );
};
PageContainer.displayName = 'PageContainer';

export default PageContainer;
